export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Der Dozent/die Dozentin war engagiert und motiviert.",
			},
			{
				id: 2,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 3,
				text: "Der Dozent/die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 4,
				text: "Der Dozent/die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 5,
				text: "Der Dozent/die Dozentin war fachlich kompetent.",
			},
			{
				id: 6,
				text: "Der Dozent/die Dozentin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 7,
				text: "Dem Dozenten/der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 8,
				text: "Der Dozent/die Dozentin motivierte die Teilnehmer/innen.",
			},
			{
				id: 9,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 10,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 11,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 12,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 13,
				text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
			},
			{
				id: 14,
				text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 15,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 16,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 17,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 18,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 19,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 20,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 21,
				text: "Hinsichtlich des organisatorischen Ablaufs der Veranstaltung (z.B. Ort, Zeit, Leistungsanforderungen) bin ich gut informiert worden.",
			},
			{
				id: 22,
				text: "Mit der Zugänglichkeit von erforderlichen Lehrmaterialien war ich zufrieden.",
			},
			{
				id: 23,
				text: "Organisatorische Fragen wurden rechtzeitig und ausführlich geklärt.",
			},
			{
				id: 24,
				text: "Der Ablauf der Veranstaltung im Verlauf des Semesters war reibungslos.",
			},
			{
				id: 25,
				text: "Die Veranstaltung war insgesamt gut organisiert.",
			},
			{
				id: 26,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 27,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 28,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 29,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 30,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 31,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 32,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
			{
				id: 33,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 34,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 35,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 36,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
			{
				id: 37,
				text: "Diese Veranstaltung war qualitativ vergleichbar mit der besten Veranstaltung, die ich in der Vergangenheit besucht habe.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 38,
				text: "Besonders gut fand ich:",
			},
			{
				id: 39,
				text: "Störend fand ich:",
			},
			{
				id: 40,
				text: "Verbesserungsvorschläge:",
			},
		],
	},
];
